
const APP_VERSION = '1.0.0';
// DEV
// const API_URL = 'http://localhost:8888';
// PRD
const API_URL = 'https://innovision.com.tw';

const headers = {
    'Content-Type': 'application/json',
};

const HTTP_METHODS = {
    GET : 'GET',
    POST : 'POST',
    DELETE : 'DELETE',
};

const TOKEN_KEY = 'I_USER_TOKEN';

export {
    APP_VERSION,
    API_URL,
    HTTP_METHODS,
    headers,
    TOKEN_KEY,
}
